<!-- Inline alert -->
<div class="scan-alert" *ngIf="alertMessage"
  [class.scan-alert-error]="alertType === 'error'"
  [class.scan-alert-warning]="alertType === 'warning'">
  {{ alertMessage }}
</div>

<!-- Wrong medicine modal -->
<div *ngIf="showWrongMedicineModal" class="wrong-med-overlay">
  <div class="wrong-med-modal">
    <div class="wrong-med-icon">&#9888;&#65039;</div>
    <h3 class="wrong-med-title">
      {{ wrongMedicineMatchStatus === 'ambiguous'
        ? 'Multiple Prescription Lines Match'
        : wrongMedicineMatchStatus === 'partial_match'
          ? (wrongMedicineMatchMethod === 'product_text' ? 'Product Name May Not Fully Match' : 'Strength Does Not Match')
          : wrongMedicineMatchStatus === 'no_match'
            ? 'Medication Not On Prescription'
            : 'Scan Could Not Be Matched' }}
    </h3>
    <p *ngIf="wrongMedicineMatchStatus === 'ambiguous'" class="wrong-med-text">
      This product matches more than one line on this prescription. Select the line you are dispensing.
    </p>
    <p *ngIf="wrongMedicineMatchStatus === 'partial_match' && wrongMedicineMatchMethod === 'product_text'" class="wrong-med-text">
      The scanned product label is similar to a line on this prescription, but not all name details match.
    </p>
    <p *ngIf="wrongMedicineMatchStatus === 'partial_match' && wrongMedicineMatchMethod !== 'product_text'" class="wrong-med-text">
      The scanned product matches an ingredient on this prescription, but the strength is different.
    </p>
    <p *ngIf="wrongMedicineMatchStatus === 'no_match' && wrongMedicineLookup" class="wrong-med-text">
      The scanned product is recognised, but it does not match any remaining line on this prescription.
    </p>

    <!-- Show identified medication if lookup succeeded -->
    <div *ngIf="wrongMedicineLookup" class="wrong-med-scanned">
      <div class="wrong-med-scanned-label">You scanned:</div>
      <div class="wrong-med-scanned-name">{{ wrongMedicineLookup.product_name }}</div>
      <div class="wrong-med-scanned-meta" *ngIf="wrongMedicineLookup.dosage_form">{{ wrongMedicineLookup.dosage_form }}</div>
      <div class="wrong-med-scanned-meta" *ngIf="wrongMedicineLookup.pack_size">{{ wrongMedicineLookup.pack_size }}</div>
      <div class="wrong-med-scanned-meta" *ngFor="let ing of wrongMedicineLookup.active_substances">
        {{ ing.name }}<span *ngIf="ing.strength"> {{ ing.strength }}</span>
      </div>
      <div class="wrong-med-scanned-barcode">Barcode: {{ wrongMedicineId }}</div>
    </div>
    <p *ngIf="!wrongMedicineLookup" class="wrong-med-text">
      Scanned barcode <strong>{{ wrongMedicineId }}</strong> — medication not recognised.
    </p>

    <!-- Option 1: Wrong drug -->
    <button class="wrong-med-btn wrong-med-btn-back" (click)="onWrongMedicineDismiss()">
      <span class="wrong-med-btn-label">Wrong Medication</span>
      <span class="wrong-med-btn-desc">I picked the wrong drug — I'll go back to stock</span>
    </button>

    <!-- Option 2: Add unknown medication (only when barcode not in any DB) -->
    <button *ngIf="!wrongMedicineLookup" class="wrong-med-btn wrong-med-btn-add" (click)="onAddUnknownMedication()">
      <span class="wrong-med-btn-label">Add This Medication</span>
      <span class="wrong-med-btn-desc">Register this drug in the database so it can be identified</span>
    </button>

    <!-- Option 3: Switch — pick which medication to replace -->
    <p class="wrong-med-note" *ngIf="exactProductNote">{{ exactProductNote }}</p>
    <div class="wrong-med-switch-section" *ngIf="wrongMedicineUnscannedMeds.length > 0">
      <div class="wrong-med-switch-label">
        {{ wrongMedicineMatchStatus === 'ambiguous'
          ? 'Select the prescription line for this scan:'
          : wrongMedicineMatchStatus === 'partial_match'
            ? (wrongMedicineMatchMethod === 'product_text'
              ? 'Select the prescription line this product may belong to:'
              : 'Select the prescription line this product belongs to:')
            : 'Or switch with a medication on this prescription:' }}
      </div>
      <button *ngFor="let med of wrongMedicineUnscannedMeds"
        class="wrong-med-btn wrong-med-btn-replace" (click)="onWrongMedicineSwitch(med)">
        <span class="wrong-med-btn-label">Switch with: {{ med.medicationName }}</span>
        <span class="wrong-med-btn-desc">{{ med.dosage }} — I've confirmed this is a correct replacement</span>
      </button>
    </div>

    <p class="wrong-med-note">
      <em>Note: Replacement label printing will be available in the next update.</em>
    </p>
  </div>
</div>

<!-- Add medication form modal -->
<div *ngIf="showAddMedicationForm" class="wrong-med-overlay" (mousedown)="$event.stopPropagation()">
  <div class="add-med-modal" (mousedown)="$event.stopPropagation()">
    <h3 class="add-med-title">Register New Medication</h3>
    <p class="add-med-barcode">Barcode: <strong>{{ wrongMedicineId }}</strong></p>

    <!-- Drug Name -->
    <div class="add-med-field">
      <label class="add-med-label">Drug Name <span class="add-med-required">*</span></label>
      <div class="add-med-input-wrap">
        <input #drugNameInput type="text" class="add-med-input" [(ngModel)]="addMedForm.productName"
          (input)="onDrugNameInput()" placeholder="Start typing drug name..." autocomplete="off">
        <div *ngIf="drugNameSuggestions.length > 0" class="add-med-suggestions">
          <div *ngFor="let s of drugNameSuggestions" class="add-med-suggestion"
            (click)="selectDrugName(s.name)">
            {{ s.name }}
            <span *ngIf="s.regionCode" class="add-med-suggestion-tag">{{ s.regionCode }}</span>
          </div>
        </div>
      </div>
      <div *ngIf="addMedWarnings.drugName" class="add-med-warning">{{ addMedWarnings.drugName }}</div>
    </div>

    <!-- Manufacturer -->
    <div class="add-med-field">
      <label class="add-med-label">Manufacturer</label>
      <div class="add-med-input-wrap">
        <input type="text" class="add-med-input" [(ngModel)]="addMedForm.manufacturer"
          (input)="onManufacturerInput()" placeholder="Manufacturer name..." autocomplete="off">
        <div *ngIf="manufacturerSuggestions.length > 0" class="add-med-suggestions">
          <div *ngFor="let m of manufacturerSuggestions" class="add-med-suggestion"
            (click)="selectManufacturer(m)">
            {{ m }}
          </div>
        </div>
      </div>
      <div *ngIf="addMedWarnings.manufacturer" class="add-med-warning">{{ addMedWarnings.manufacturer }}</div>
    </div>

    <!-- Dosage Form -->
    <div class="add-med-field">
      <label class="add-med-label">Dosage Form</label>
      <select class="add-med-input" [(ngModel)]="addMedForm.dosageForm">
        <option value="">— Select —</option>
        <option *ngFor="let form of dosageFormOptions" [value]="form">{{ form }}</option>
      </select>
    </div>

    <!-- Active Substances -->
    <div class="add-med-field">
      <label class="add-med-label">Active Substances</label>
      <input type="text" class="add-med-input" [(ngModel)]="addMedForm.activeSubstances"
        placeholder="e.g. Paracetamol 500mg" autocomplete="off">
    </div>

    <!-- Pack Size -->
    <div class="add-med-field">
      <label class="add-med-label">Pack Size</label>
      <input type="text" class="add-med-input" [(ngModel)]="addMedForm.packSize"
        placeholder="e.g. 28 tablets" autocomplete="off">
    </div>

    <!-- Actions -->
    <div class="add-med-actions">
      <button class="add-med-btn-cancel" (click)="onCancelAddMedication()">Cancel</button>
      <button class="add-med-btn-save" (click)="onSaveNewMedication()"
        [disabled]="!addMedForm.productName.trim() || addMedSaving">
        {{ addMedSaving ? 'Saving...' : 'Save Medication' }}
      </button>
    </div>
  </div>
</div>

<!-- Prescription selector -->
<div class="rx-selector" *ngIf="!isScanComplete && prescriptionIds.length > 0">
  <label class="rx-selector-label">Prescription:</label>
  <select class="ss-select" (change)="jumpToPrescription($event)">
    <option *ngFor="let id of prescriptionIds" [value]="id">
      {{ groupedMedications[id].patientName }}
    </option>
  </select>
</div>

<!-- Main scan area -->
<div class="scan-container" *ngIf="prescriptionIds.length > 0 && !isScanComplete">
  <div class="scan-progress-bar">
    <span class="scan-progress-text">
      Patient <strong>{{ currentPrescriptionIndex + 1 }}</strong> of <strong>{{ prescriptionIds.length }}</strong>
    </span>
    <span class="scan-instruction">Scan medications for each patient prescription.</span>
  </div>

  <div class="patient-section">
    <div class="patient-bar">
      <div class="patient-info">
        <span class="patient-name">{{ currentPatientName }}</span>
        <span class="patient-dob" *ngIf="currentPrescription?.patientDob">DOB {{ currentPrescription.patientDob | dob }}</span>
        <span class="patient-location" *ngIf="currentPrescription?.patientLocation">{{ currentPrescription.patientLocation }}</span>
        <span class="med-count">{{ currentMedicines.length }} meds</span>
      </div>
      <div class="patient-nav">
        <button class="ss-btn ss-btn-secondary ss-btn-sm" *ngIf="!isFirstPrescription && !isScanComplete"
          (click)="previousPatient()">Previous</button>
        <button class="ss-btn ss-btn-primary ss-btn-sm" *ngIf="!isLastPrescription && isStartBtnClicked"
          (click)="nextPatient()">Next</button>
        <button class="ss-btn ss-btn-success ss-btn-sm" *ngIf="isLastPrescription && !isScanComplete && isStartBtnClicked && !viewOnly"
          (click)="finishScan()">Finish</button>
        <button class="ss-btn ss-btn-secondary ss-btn-sm" data-test="reprint-bag-labels" *ngIf="canReprintBags"
          (click)="openBagReprint()">Reprint bag labels</button>
      </div>
    </div>

    <div class="bag-progress" *ngIf="isMpsBatch">
      <span *ngFor="let b of bagStatus; trackBy: trackByBag" class="bag-chip" [class.bag-chip--done]="b.total > 0 && b.done === b.total"
            [attr.data-bag]="b.bagId">
        Bag {{ b.bagId }} · {{ b.patientName }} · {{ b.done }}/{{ b.total }}<span *ngIf="b.labelled"> · labelled</span>
      </span>
    </div>
    <!-- Medication grid -->
    <div class="med-grid">
      <div *ngFor="let medicine of currentMedicines" class="med-card"
        [class.med-card-scanned]="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED'"
        [class.med-card-replaced]="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'REPLACED'">

        <div class="med-scan-label"
          [class.scanned]="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED'"
          [class.replaced]="scanStatuses[currentPrescriptionId][medicine.medicationId] === 'REPLACED'">
          {{ scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED' ? 'SCANNED'
           : scanStatuses[currentPrescriptionId][medicine.medicationId] === 'REPLACED' ? 'REPLACED'
           : 'NOT SCANNED' }}
        </div>

        <!-- Replaced card: show original + replacement -->
        <ng-container *ngIf="medicine.replacedBy; else normalCard">
          <div class="med-original">
            <div class="med-original-label">Originally prescribed</div>
            <div class="med-original-name">{{ medicine.medicationName }}</div>
            <div class="med-original-dosage">{{ medicine.dosage }}</div>
          </div>
          <div class="med-replaced-divider">
            <span class="med-replaced-arrow">&#8595;</span> replaced with
          </div>
          <div class="med-replacement">
            <div class="med-replacement-name">{{ medicine.replacedBy }}</div>
            <div class="med-replacement-dosage" *ngIf="medicine.replacedByDosage">{{ medicine.replacedByDosage }}</div>
          </div>
        </ng-container>

        <!-- Normal card -->
        <ng-template #normalCard>
          <div class="med-id" *ngIf="showMedicationId">{{ medicine.medicationId }}</div>
          <div class="med-card-name text-break">{{ medicine.medicationName }}</div>
          <div class="med-card-dosage text-break">{{ medicine.dosage }}</div>
          <div class="med-card-quantity text-break" *ngIf="medicine.quantity != null">Qty: {{ medicine.quantity }}</div>
          <app-med-badges [packSize]="medicine.packSize" [fullPacks]="medicine.fullPacks" [bagId]="medicine.bagId"
                          [marking]="medicine.marking" [doNotSubstitute]="medicine.doNotSubstitute"></app-med-badges>
        </ng-template>

        <button
          *ngIf="!viewOnly && (scanStatuses[currentPrescriptionId][medicine.medicationId] === 'SCANNED' || scanStatuses[currentPrescriptionId][medicine.medicationId] === 'REPLACED')"
          class="med-remove-btn"
          (click)="onCancel(medicine)">
          Remove
        </button>
      </div>
    </div>
  </div>

  <!-- Previously scanned patients -->
  <div class="scanned-patients" *ngIf="currentPrescriptionIndex > 0">
    <div *ngFor="let scannedId of prescriptionIds.slice(0, currentPrescriptionIndex)" class="scanned-patient">
      <div class="scanned-header" (click)="toggleCollapse(scannedId)">
        <strong>{{ groupedMedications[scannedId]?.patientName }}</strong>
        <span class="scanned-count">{{ getScannedCount(scannedId) }}/{{ groupedMedications[scannedId]?.medicines.length }}</span>
        <span class="toggle-link">{{ expandedPrescriptionId === scannedId ? 'Hide' : 'Show' }}</span>
      </div>
      <div *ngIf="expandedPrescriptionId === scannedId" class="scanned-detail">
        <div *ngFor="let med of groupedMedications[scannedId]?.medicines" class="scanned-med-row">
          <span *ngIf="!med.replacedBy">{{ med.medicationName }} — {{ med.dosage }}</span>
          <span *ngIf="med.replacedBy">{{ med.medicationName }} &#8594; {{ med.replacedBy }}</span>
          <span class="scanned-med-status"
            [class.status-ok]="scanStatuses[scannedId]?.[med.medicationId] === 'SCANNED' || scanStatuses[scannedId]?.[med.medicationId] === 'REPLACED'"
            [class.status-pending]="scanStatuses[scannedId]?.[med.medicationId] === 'PENDING'">
            {{ scanStatuses[scannedId]?.[med.medicationId] || 'UNKNOWN' }}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Printer selection modal -->
<div *ngIf="showPrinterSelectionModal" class="printer-overlay">
  <div class="printer-modal">
    <h3 class="printer-modal-title">Select Printer</h3>
    <select class="ss-select" [(ngModel)]="selectedPrinter" style="width:100%;margin-bottom:14px">
      <option *ngFor="let printer of availablePrinters" [value]="printer">{{ printer }}</option>
    </select>
    <button (click)="printPreference()" class="ss-btn ss-btn-primary" style="width:100%">Select</button>
  </div>
</div>

<!-- Batch summary (after scan complete) -->
<div *ngIf="isScanComplete" class="batch-summary">
  <h5 class="summary-title">Batch Summary</h5>
  <!-- After Finish, labels that didn't print (NS Tray off) can still be printed from here. -->
  <button class="ss-btn ss-btn-secondary ss-btn-sm" data-test="reprint-bag-labels" *ngIf="canReprintBags"
    (click)="openBagReprint()">Reprint bag labels</button>
  <table class="ss-table">
    <thead>
      <tr>
        <th>Patient Name</th>
        <th>Remaining</th>
        <th>Remark</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let id of prescriptionIds">
        <td>{{ groupedMedications[id]?.patientName }}</td>
        <td>{{ groupedMedications[id]?.medicines?.length - getScannedCount(id) }}</td>
        <td *ngIf="getScannedCount(id) < groupedMedications[id]?.medicines?.length"
          style="color:var(--color-danger);font-style:italic">
          Some medications not scanned
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-bag-reprint-panel *ngIf="showBagReprint" [batch]="batchData" (printed)="onBagsReprinted($event)" (closed)="closeBagReprint()"></app-bag-reprint-panel>
